import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        count: 0,
        customerList:[],
        optionset:[],
        num:0,
        mainId:'',
        uid:''
    },
    mutations: {
        increment (state,payload) {
            payload.checked=false
            state.customerList.push(payload)
        },
        optionAdd(state,payload){
            payload.radio=1
            state.optionset.push(payload)
        },
        deleteOption(state,index){
            state.optionset.splice(index,1)
        },
        numAdd(state,payload){
            state.num=payload
        },
        numSum(state,payload){
            state.num=payload
        },
        mainIdSet(state,payload){
            state.mainId = payload
        },
        uidSet(state,payload){
            state.uid = payload
        }
    }
})
export default store